import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Circle, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { selectCurrentUserIconColor, setUserIconColor } from '../../redux/modules/activityLog';
import { getUserFullName, getUserInitials } from '../../utils/userNameUtil';

const UserIcon = ({
  firstName,
  lastName,
  iconSize = '35px',
  fontSize = 'sm',
  fontWeight = 'semibold',
  disabled = false,
  zIndex = 1,
  ml = '0 auto',
  border = '0px solid',
  borderColor = 'transparent'
}) => {
  const dispatch = useDispatch();

  const userInitials = getUserInitials(firstName, lastName);
  const userFullName = getUserFullName(firstName, lastName);
  const userIcon = useSelector(selectCurrentUserIconColor(userInitials));

  useEffect(() => {
    dispatch(setUserIconColor(userInitials));
  });

  const getIconColor = () => {
    if (userIcon) return userIcon.appliedColor;
    return 'primaryScale.600';
  };

  return (
    <Tooltip label={userFullName}>
      <Circle
        bg={disabled ? 'greyScale.800' : getIconColor()}
        border={border}
        borderColor={borderColor}
        color="white"
        fontSize={fontSize}
        fontWeight={fontWeight}
        ml={ml}
        size={iconSize}
        zIndex={zIndex}
      >
        {userInitials}
      </Circle>
    </Tooltip>
  );
};

UserIcon.propTypes = {
  /** User first name. Max of three initials total between first and last name */
  firstName: PropTypes.string.isRequired,
  /** User last name. Max of three initials total between first and last name */
  lastName: PropTypes.string.isRequired,
  /** 35px or specified size --> TODO: change to theme size */
  iconSize: PropTypes.string,
  /** Font size */
  fontSize: PropTypes.string,
  /** Font weight */
  fontWeight: PropTypes.string,
  /** Set disabled to true for inactive users  */
  disabled: PropTypes.bool,
  /** Specify if overlapping multiple icons */
  zIndex: PropTypes.number,
  /** Specify if overlapping multiple icons */
  ml: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Specify if overlapping multiple icons */
  border: PropTypes.string,
  /** Specify if overlapping multiple icons */
  borderColor: PropTypes.string
};

export default UserIcon;
